/* @import '../../global/min-app.css'; */

:host {
  @apply selection:text-dark-blue selection:bg-logo-orange;
  display: block;
}

.super-scroll-block {
  @apply w-full h-auto rounded-[12px] relative overflow-hidden mx-auto block pl-56px pt-64px;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
}

.super-scroll-block .super-scroll-block-bg {
  @apply w-full h-full absolute top-0 left-0 z-10 opacity-100;
  transition: all 500ms ease;
}

.super-scroll-block .super-scroll-block-bg.fade-out-slide {
  @apply opacity-0;
}

.super-scroll-block .super-scroll-block-bg-overlay { 
  @apply w-full h-full absolute top-0 left-0 opacity-60 bg-black;
  z-index: 11;
}

.super-scroll-block .super-scroll-block-background-image {
  @apply w-full h-full;
  transition: all 500ms ease;
  object-fit: cover;
  object-position: center;
}

.super-scroll-block-top-content {
  @apply w-full h-auto max-w-[640px] mx-auto text-center relative z-30;
}

.super-scroll-block-top-content .super-scroll-block-top-title {
  @apply w-full h-auto text-5 sm:text-7 md:text-9 lg:text-11 font-poppins font-bold;
}

.super-scroll-block-top-content .super-scroll-block-top-description {
  @apply w-full h-auto text-0 md:text-1 font-poppins mt-12px mb-0;
}

.super-scroll-block .super-scroll-block-slides-container {
  @apply w-full h-auto min-h-[320px] block mt-[77px] relative z-30;
}

.super-scroll-block .super-scroll-block-slides-container .super-scroll-block-slide {
  @apply w-full h-auto min-h-[320px] flex flex-col sm:flex-row justify-between items-stretch gap-y-[32px] gap-x-[24px] md:gap-x-[56px] opacity-0;
  /* absolute top-0 left-0 */
}

.super-scroll-block .super-scroll-block-slides-container .super-scroll-block-slide.scroll-active {
  @apply opacity-100;
  /* animation: fadeInBot 150ms ease 0s 1 normal forwards; */
}

.super-scroll-block .super-scroll-block-slides-container .super-scroll-block-slide.scroll-remove-active {
  /* @apply opacity-100; */
  /* animation: fadeOutTop 150ms ease 0s 1 normal forwards; */
}

.super-scroll-block .super-scroll-block-slides-container .super-scroll-block-slide .super-scroll-block-slide-content {
  @apply w-full h-auto flex flex-col items-start justify-center sm:py-72px opacity-0 pl-[20px] md:pl-0;
  transition: all 500ms ease; 
}

.super-scroll-block .super-scroll-block-slides-container .super-scroll-block-slide.scroll-active.loaded .super-scroll-block-slide-content {
  @apply opacity-100;
}

.super-scroll-block .super-scroll-block-slides-container .super-scroll-block-slide.scroll-active.loaded .super-scroll-block-slide-content.fade-out-slide {
  @apply opacity-0;
}

.super-scroll-block .super-scroll-block-slides-container .super-scroll-block-slide .super-scroll-block-slide-title {
  @apply w-full h-auto text-3 sm:text-4 md:text-5 lg:text-6 font-poppins font-bold;
}

.super-scroll-block .super-scroll-block-slides-container .super-scroll-block-slide .super-scroll-block-slide-description {
  @apply w-full h-auto text-0 md:text-1 font-poppins pt-12px;
}

.super-scroll-block .super-scroll-block-slides-container .super-scroll-block-slide .super-scroll-block-slide-card {
  @apply w-full h-auto bg-white rounded-l-[12px] text-black py-[32px] px-[20px] sm:p-32px;
  transform: translateX(100%);
  transition: all 500ms ease;
}

.super-scroll-block .super-scroll-block-slides-container .super-scroll-block-slide .super-scroll-block-slide-card .super-scroll-block-slide-card-content{
  @apply w-full h-auto flex flex-col items-start justify-start gap-y-[16px] opacity-0;
  transition: all 500ms ease;
}

.super-scroll-block .super-scroll-block-slides-container .super-scroll-block-slide.scroll-active.loaded .super-scroll-block-slide-card {
  transform: translateX(0%);
}

.super-scroll-block .super-scroll-block-slides-container .super-scroll-block-slide.scroll-active.loaded .super-scroll-block-slide-card .super-scroll-block-slide-card-content{
  @apply opacity-100;
}


.super-scroll-block .super-scroll-block-slides-container .super-scroll-block-slide.scroll-active.loaded .super-scroll-block-slide-card .super-scroll-block-slide-card-content.fade-out-slide {
  @apply opacity-0;
}
.super-scroll-block-tabs-container {
  @apply w-full h-auto flex flex-col items-end relative mt-[42px] mb-24px pr-24px z-40;
}

.super-scroll-block-tabs-container .super-scroll-block-tab {
  @apply w-full h-auto flex flex-row justify-end items-center gap-x-[7px] cursor-pointer py-[6px];
}

.super-scroll-block-tabs-container .super-scroll-block-tab .super-scroll-block-tab-bar {
  @apply w-16px h-2px bg-white rounded-[12px] cursor-pointer;
  transition: width 150ms ease;
}

.super-scroll-block-tabs-container .super-scroll-block-tab .super-scroll-block-tab-bar-count {
  @apply min-w-[10px];
}

.super-scroll-block-tabs-container .super-scroll-block-tab.scroll-active .super-scroll-block-tab-bar {
  @apply w-32px;
}

.super-scroll-block-bottom-buttons {
  @apply w-fit h-auto absolute left-[50%] z-30 flex justify-center items-center;
  transform: translateX(-50%);
}

.super-scroll-block-bottom-buttons a {
  @apply w-fit h-auto;
}

.super-scroll-block-bottom-buttons .small-primary,
.super-scroll-block-bottom-buttons .small-secondary {
  @apply w-fit h-auto mb-[6px];
}

.super-scroll-block-slide-card-logo {
 @apply max-h-100px;
}

.bottom-pb-medium {
  @apply bottom-16px sm:bottom-20px md:bottom-24px lg:bottom-[28px];
}

/* animation: fadeInBot 150ms ease 0s 1 normal forwards; */
@keyframes fadeInBot {
	0% {
		opacity: 0;
		transform: translateY(50px);
	}

	100% {
		opacity: 1;
		transform: translateY(0);
	}
}

/* animation: fadeOutTop 150ms ease 0s 1 normal forwards; */
@keyframes fadeOutTop {
	0% {
		opacity: 1;
		transform: translateY(0);
	}

	100% {
		opacity: 0;
		transform: translateY(-50px);
	}
}